/* eslint-disable no-restricted-properties */
const cnfsd = (function () {
	const mobile = window.matchMedia('(max-width: 740px)'),
		watched = document.querySelectorAll('.section'),
		leftScroller = document.querySelector('.cw-table__button--left'),
		rightScroller = document.querySelector('.cw-table__button--right'),
		tableContainer = document.querySelector('.cw-table__scroller'),
		table = document.querySelector('.cw-table'),
		tableNotesArea = document.querySelector('.cw-table__table-notes'),
		tableIntro = document.querySelector('.cw-table__intro'),
		accordions = document.querySelectorAll('.accordion__item');

	// eslint-disable-next-line no-unused-vars
	let options;
	const cmsData = document.querySelector('[data-json]'),
		jsonCMS = cmsData.getAttribute('data-json'),
		tableIntroCMS = cmsData.getAttribute('data-table-intro'),
		tableNotesCMS = cmsData.getAttribute('data-table-notes');

	function init() {
		accordionInteractions();

		if (jsonCMS) {
			// PARSE JSON STRING INTO OBJECT
			const jsonData = JSON.parse(jsonCMS);

			if (Object.keys(jsonData).length > 0) {
				// eslint-disable-next-line no-unused-vars
				const tableCreator = new CreateTable(
					jsonData,
					leftScroller,
					rightScroller,
					table,
					tableContainer,
					tableNotesArea,
					tableIntro
				);
			}

			// Instigates class -> tableData is jsonObject that is used to create table

			// CALL INTERSECTION OBSERVER TO OBSERVE EACH SECTION
			for (let i = 0; i < watched.length; i++) {
				// eslint-disable-next-line no-undef
				observer.observe(watched[i]);
			}

			// OPTIONS FOR INTERSECTION OBSERVER
			if (mobile.matches) {
				options = {
					root: null,
					//threshold: 0.25,
					rootMargin: '0px',
				};
			} else {
				options = {
					root: null,
					threshold: 0.75,
					rootMargin: '0 0 -275px 0',
				};
			}
		}
	}

	function accordionInteractions() {
		if (!accordions.length) return;
		accordions.forEach(accordion => {
			const button = accordion.querySelector('button');
			accordion.addEventListener('click', e => {
				const accordionItem = e.target.closest('.accordion__item');
				if (!accordionItem.classList.contains('accordion__item--active')) {
					button.setAttribute('aria-expanded', true);
					accordionItem.classList.add('accordion__item--active');
				} else {
					button.setAttribute('aria-expanded', false);
					accordionItem.classList.remove('accordion__item--active');
				}
			});
		});
	}

	class CreateTable {
		//TABLE NEEDS AT LEAST 3 ROWS (EXCLUDING TABLE HEADER) TO WORK - Will add logic eventually to cater for this
		constructor(tableScaffold, leftScroller, rightScroller, table, tableContainer, tableNotesArea, tableIntro) {
			this.tableScaffold = tableScaffold;
			this.leftScroller = leftScroller;
			this.rightScroller = rightScroller;
			this.table = table;
			this.tableContainer = tableContainer;
			this.tableTopPadding = 100;
			this.tableNotesArea = tableNotesArea;
			this.tableIntro = tableIntro;
			this.currentToolTipActive = null;

			if (this.tableScaffold) this.populateHTML();

			if (tableScaffold.tableData) {
				this.createTableHeaders(); //creates the table headings for table
				this.createTableData(); //creates the table data for table

				this.scrollRightXPositioning(); // positions the right-side scroll button
				this.scrollLeftXPositioning(); // positions the left-side scroll button

				let resizeTimer;
				window.addEventListener('resize', () => {
					// runs recalculations if the page is scrolled
					this.scrollLeftXPositioning();
					this.scrollRightXPositioning();
					this.removeToolTip();
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(this.reCalcOnResize, 200);
				});

				this.leftScroller.addEventListener('click', this.scrollTableLeft); // scroll table left when pressed
				this.leftScroller.addEventListener('keydown', event => {
					if (event.key === 'Enter') {
						this.scrollTableLeft();
					}
				});

				this.rightScroller.addEventListener('click', this.scrollTableRight); // scroll table right when pressed
				this.rightScroller.addEventListener('keydown', event => {
					if (event.key === 'Enter') {
						this.scrollTableRight();
					}
				});

				this.createScrollIntersection(); // initiates intersection observer
			}
		}

		populateHTML = () => {
			if (tableNotesCMS) this.tableNotesArea.innerHTML = tableNotesCMS;
			if (tableIntroCMS) this.tableIntro.innerText = tableIntroCMS;
		};

		reCalcOnResize = () => {
			// re-run functions to correct the positions to the new observer root margin & new page width

			this.observer.unobserve(this.observedTableRow); // remove the prior observer
			this.scrollLeftXPositioning();
			this.scrollRightXPositioning();
			this.hideScrollersIfOverflow();
			this.createScrollIntersection();
		};

		hideScrollersIfOverflow = () => {
			//add/remove scrollers & overflow if the table is overflowing/not setting attributes so scrollers are tabbable
			const scrollTable = document.querySelector('.cw-table__scroller');

			if (this.table.clientWidth > this.tableContainer.clientWidth) {
				this.leftScroller.style.display = 'block';
				this.leftScroller.setAttribute('tabindex', 0);
				this.rightScroller.style.display = 'block';
				this.rightScroller.setAttribute('tabindex', 0);
				scrollTable.style.overflowX = 'scroll';
			} else {
				this.leftScroller.style.display = 'none';
				this.rightScroller.style.display = 'none';
				scrollTable.style.overflowX = 'hidden';
			}
		};

		createScrollIntersection = () => {
			//creates the scroll observer
			this.observedTableRow = Array.from(this.table.rows).pop(); //gets the bottom table row

			//rootMargin's top is calculated from the top of the bottom table row to where the top of the table intersect + the padding of the buffer
			//This is done by adding the table height to the buffer, minus the height of the table row (50px)
			//this is then subtracted from the window to give the correct distance from the bottom of the window (to cater for varied screen sizes)
			//the value is flipped from positive to negative as it is a positive margin

			const options = {
				root: null,
				// rootMargin: `-218px 0px ${(window.innerHeight - (this.table.clientHeight + this.tableTopPadding - 50)) * -1}px 0px`,
				rootMargin: `-240px 0px ${(window.innerHeight - (this.table.clientHeight + this.tableTopPadding - 50)) * -1}px 0px`,
				threshold: 0,
			};

			this.observer = new IntersectionObserver(this.handleIntersect, options);
			this.observer.observe(this.observedTableRow);
		};

		handleIntersect = entries => {
			const headerRow = document.querySelector('.cw-table thead tr th');
			this.headerRow = headerRow.clientHeight + 2;
			// const tdCell = document.querySelector('.cw-table tbody tr td');
			const tableTopPosition = this.table.getBoundingClientRect().top;

			entries.forEach(entry => {
				if (entry.isIntersecting) {
					//if the table is intersecting

					// position header to below the table header row and the intersect padding (to maintain its position)
					this.leftScroller.style.top = `${this.headerRow + this.tableTopPadding}px`;
					this.rightScroller.style.top = `${this.headerRow + this.tableTopPadding}px`;

					//change position to fixed
					this.leftScroller.style.position = 'fixed';
					this.rightScroller.style.position = 'fixed';

					//x positions needs re-calculating as left values were based on absolute positions
					this.scrollLeftXPositioning();
					this.scrollRightXPositioning();
				} else if (!entry.isIntersecting && Math.sign(tableTopPosition) == 1) {
					//if the table is not intersecting but the table top is in the viewport

					//set the position back to the top of the table
					this.rightScroller.style.top = `${this.headerRow}px`;
					this.leftScroller.style.top = `${this.headerRow}px`;

					//set the position back to absolute
					this.rightScroller.style.position = 'absolute';
					this.leftScroller.style.position = 'absolute';

					//x positions needs re-calculating as left values are now based on fixed positions
					this.scrollLeftXPositioning();
					this.scrollRightXPositioning();
				} else if (!entry.isIntersecting && Math.sign(tableTopPosition) == -1) {
					//if the table is not intersecting but the table top is NOT in the viewport

					//sets the scrollers to the bottom of the table
					this.leftScroller.style.top = `${this.table.clientHeight - 48}px`; //48px height of scrollers
					this.rightScroller.style.top = `${this.table.clientHeight - 48}px`; //48px height of scrollers

					//set the position back to absolute
					this.rightScroller.style.position = 'absolute';
					this.leftScroller.style.position = 'absolute';

					//x positions needs re-calculating as left values are now based on fixed positions
					this.scrollRightXPositioning();
					this.scrollLeftXPositioning();
				}
			});
		};

		removeToolTip = () => {
			if (this.currentToolTipActive) {
				const tooltip = document.querySelector('.cw-table__tooltip');
				const tooltipToggles = document.querySelectorAll('.cw-table thead tr th span:nth-of-type(2)');

				tooltip.classList.remove('cw-table__tooltip--active');

				//REMOVE ALL BLUE TOGGLES
				tooltipToggles.forEach(toggle => {
					toggle.classList.remove('active');
				});

				return (this.currentToolTipActive = null);
			}
		};

		createTableToolTip = () => {
			const tooltip = document.createElement('div'),
				description = document.createElement('div'),
				triangle = document.createElement('span'),
				closeButton = document.createElement('span'),
				descriptionContent = document.createElement('div');

			tooltip.classList.add('cw-table__tooltip');
			const tableContainer = document.querySelector('.cw-table__container');
			triangle.classList.add('cw-table__tooltip__triangle');
			description.classList.add('cw-table__tooltip__content');

			closeButton.innerHTML = '&#10005;';
			closeButton.addEventListener('click', () => this.removeToolTip());
			closeButton.addEventListener('keyup', () => this.removeToolTip());

			description.appendChild(closeButton);
			description.appendChild(descriptionContent);
			tooltip.appendChild(description);
			tooltip.appendChild(triangle);
			tableContainer.appendChild(tooltip);

			//IF USER CLICKS ON ANYWHERE ON TABLE TO REMOVE TOOLTIP
			this.table.addEventListener('click', e => {
				const tooltipToggles = document.querySelectorAll('.cw-table thead tr th span:nth-of-type(2)');

				if (this.currentToolTipActive) {
					//LOOPS THROUGH AND REMOVES COLOUR IF NOT A MATCH
					tooltipToggles.forEach(toggle => {
						if (e.target !== toggle) {
							toggle.classList.remove('active');
						}
					});

					//CHECKS IF CURRENT ACTIVE TOOLTIP IS THE SAME ONE AND CLOSES IT
					if (this.currentToolTipActive !== e.target) {
						tooltip.classList.remove('cw-table__tooltip--active');
						return (this.currentToolTipActive = null);
					}
				}
			});
		};

		handleTooltipClicked = (e, text) => {
			const tableContainer = document.querySelector('.cw-table__container');
			const tableLeftPosition = tableContainer.getBoundingClientRect().left;
			const leftPosition = e.target.getBoundingClientRect().left;
			const tooltip = document.querySelector('.cw-table__tooltip');
			const description = document.querySelector('.cw-table__tooltip__content');
			const descriptionContent = document.querySelector('.cw-table__tooltip__content > div');

			tooltip.classList.add('cw-table__tooltip--active'); //SHOW TOOLTIP
			descriptionContent.innerText = text;

			const triangle = tooltip.querySelector('.cw-table__tooltip__triangle');

			const leftPositionAsPercent = ((leftPosition - tableLeftPosition) / tooltip.clientWidth) * 100;

			//CALS TO POSITION THE TRIANGLE AND TOOLTIP ON THE TABLE
			triangle.style.left = `${leftPositionAsPercent - 0.16}%`;
			description.style.left = `${leftPositionAsPercent}%`;
			description.style.transform = `translate(-${leftPositionAsPercent - leftPositionAsPercent / 12}%, 0)`;
		};

		createTableHeaders = () => {
			const tHead = document.createElement('thead');
			const row = document.createElement('tr');

			const tableHeaders = this.tableScaffold.tableHeaders; //map jsonData

			tableHeaders.map(header => {
				//map first object
				const th = document.createElement('th');

				const span = document.createElement('span');
				span.tabIndex = 0;
				span.innerHTML = '?';

				if (header.headerName === 'Which? Customer score') {
					//if the header is 'which? customer score', replace with image
					const img = document.createElement('img');
					const imgContainer = document.createElement('span');
					//img.src = "./images/shared/which-customer-score.svg";
					img.alt = 'Which customer score';
					img.classList.add('customer-score-img');
					//img.src="https://www.confused.com/static/cmsmedia/custom-cms-widgets/code/which/redesign/test/shared/images/which-customer-score.svg";
					img.src =
						'https://www.confused.com/static/cmsmedia/custom-cms-widgets/code/which/redesign/shared/images/which-customer-score.svg';
					imgContainer.appendChild(img);
					th.appendChild(imgContainer);
					th.appendChild(span);
					row.appendChild(th);
				} else {
					th.innerHTML = `<span>${header.headerName}</span>`;

					if (header.toggleText !== null) {
						//IF TOGGLE TEXT EXISTS
						th.appendChild(span);
					}
					row.appendChild(th);
				}

				span.addEventListener('click', e => {
					//IF THE USER CLICKS THE TOOLTIP TOGGLE THAT ALREADY IS OPEN, CLOSE IT
					if (this.currentToolTipActive === e.target) {
						e.target.classList.remove('active');
						const tooltip = document.querySelector('.cw-table__tooltip');
						tooltip.classList.remove('cw-table__tooltip--active');
						this.currentToolTipActive = null;
						return;
					}

					//SHOW TOOLTIP
					this.currentToolTipActive = e.target;
					e.target.classList.add('active');
					this.handleTooltipClicked(e, header.toggleText);
				});

				span.addEventListener('keydown', e => {
					if (e.key === 'Enter') {
						if (this.currentToolTipActive === e.target) {
							e.target.classList.remove('active');
							this.currentToolTipActive = null;
							return;
						}
						this.currentToolTipActive = e.target;
						e.target.classList.add('active');
						this.handleTooltipClicked(e, header.toggleText);
					}
				});
			});

			tHead.appendChild(row);
			this.table.appendChild(tHead); //append to table
			this.createTableToolTip();
		};

		generateTableStars = (brand, stepCount) => {
			//creates the stars for table data
			const td = document.createElement('td');

			for (let step = 1; step < stepCount; step++) {
				// for each star,
				const redStar = '<span class="star--red">&#9733</span>';
				const greyStar = '<span class="star--grey">&#9733</span>';
				brand >= step ? (td.innerHTML += redStar) : (td.innerHTML += greyStar); //change colour of stars depending if the step is smaller than the number desired
			}

			td.innerHTML += `<div>${brand} out of ${stepCount - 1}</div>`;
			return td;
		};

		createTableData = () => {
			//creates table data
			const tBody = document.createElement('tbody');

			this.tableScaffold.tableData.map(brand => {
				const row = document.createElement('tr');
				for (const key in brand) {
					const td = document.createElement('td');

					if (typeof brand[key] === 'number' && brand[key] !== null) {
						// if the data in the tableData is a number & is not null (means it's star data)
						const starTd = this.generateTableStars(brand[key], 6);
						row.appendChild(starTd);
					} else if (brand[key] === null) {
						td.innerHTML = '-';
						row.appendChild(td);
					} else {
						td.innerHTML = brand[key];
						row.appendChild(td);
					}
				}
				tBody.appendChild(row);
			});
			this.table.appendChild(tBody);
			this.hideScrollersIfOverflow(); // checks if table is overflowing, hides scroller buttons if so
		};

		scrollTableRight = () => {
			//when table right is clicked, scroll the table container by 100px right
			this.tableContainer.scrollBy({
				top: 0,
				left: 100,
				behavior: 'smooth',
			});

			this.removeToolTip();
		};

		scrollTableLeft = () => {
			//when table left is clicked, scroll the table container by 100px left
			this.tableContainer.scrollBy({
				top: 0,
				left: -100,
				behavior: 'smooth',
			});
			this.removeToolTip();
		};

		scrollRightXPositioning = () => {
			//positions the table right scroller
			const containerW = this.tableContainer.clientWidth;

			//determines the current position of the scrollers and updates the scrollers accordingly
			if (this.rightScroller.style.position === 'absolute') {
				this.rightScroller.style.left = `${containerW + 1 - 50}px`; //1px for border
			} else {
				const tableLeftPosition = this.tableContainer.getBoundingClientRect().right;
				this.rightScroller.style.left = `${tableLeftPosition - 50}px`;
			}
		};

		scrollLeftXPositioning = () => {
			//positions the table left scroller
			const firstCell = document.querySelector('.cw-table thead tr th');

			//determines the current position of the scrollers and updates the scrollers accordingly
			if (this.leftScroller.style.position === 'absolute') {
				this.leftScroller.style.left = `${firstCell.clientWidth + 1}px`; //1px for border
			} else {
				const tableLeftPosition = firstCell.getBoundingClientRect().left;
				this.leftScroller.style.left = `${tableLeftPosition + firstCell.clientWidth + 1}px`;
			}
		};
	}

	return {
		init: init,
	};
})();

window.addEventListener('load', function () {
	cnfsd.init();
});
